import { GraphQLClient } from '@meterup/graphql';

const proxyPath = import.meta.env.PROXY_PATH ?? '/api-proxy';
export const apiBaseURL = `${import.meta.env.REACT_APP_API_URL}${proxyPath}`;
export const graphQLURL = `${apiBaseURL}/v2/graphql`;

export const graphQLClient = new GraphQLClient(graphQLURL, {
  credentials: 'include',
  errorPolicy: 'all',
});
